<h3-linked-radio-button-dropdown
  [dropdownTitle]="'Steps'"
  [dropdownItems]="steps$ | async"
  matMenuClass="steps-menu"
></h3-linked-radio-button-dropdown>
